import { createRoot } from 'react-dom/client';
import UserNavPrompt from './UserNavPrompt';

/* 

This is a function for exclusive use with React Router's getUserConfirmation function.
To use it, place a <Promp /> component in the component that requires a prompt.

e.g. <Prompt when={hasUnsavedChanges} message="Are you sure you want to leave?"/>

In the Router component, pass this function to getUserConfirmation.
e.g. <Router getUserConfirmation={UserNavPrompt}>

This will replace the default window.prompt browser based UI with <UserNavPrompt />

*/

const UserNavPromptFn = (message: string, cb: (ok: boolean) => void): void => {
  const container = createDomContainer();

  const closeModal = (_ok: boolean) => () => cb(_ok);

  const root = createRoot(container);

  root.render(<UserNavPrompt message={message} onConfirm={closeModal(true)} onCancel={closeModal(false)} />);
};

function createDomContainer() {
  const existingContainer = document.getElementById('vopay-confirm-navigation');
  const container = document.createElement('div');

  if (existingContainer) removeDomContainer(existingContainer);

  container.setAttribute('id', 'vopay-confirm-navigation');
  document.body.appendChild(container);

  return container;
}

function removeDomContainer(container: HTMLElement): void {
  const root = createRoot(container);
  root.unmount();
  document.body.removeChild(container);
}

export default UserNavPromptFn;
